import { IEnvironment } from 'src/app/modules/shared/models/interfaces/environment.interface';

export const environment: IEnvironment = {
  CONFIGURATION: 'production',
  API_URL: 'https://apiv3.wetrack.com',
  DEFAULT_AVATAR: 'https://api.wetrack.com/Resource/assets/images/icon-user-grey.png',
  DEFAULT_AVATAR_INVERSE: 'https://api.wetrack.com/Resource/assets/images/icon-user-white.png',
  CDN_URL: 'https://api.wetrack.com/resource/',
  GANTT_EXPORT_URL: 'https://ganttexporter.wetrack.com/gantt',
  DHX_GRID_EXPORT_URL: 'https://gridexporter.wetrack.com/excel',
  API_VERSION: 'v1',
  Issuer: 'https://auth.wetrack.com',
  clientId: 'com.wetrack.frontend.spa.client.live',
  tenantId: 'c9e473eb-9742-4846-a162-76ce5edfcefb',
  intercomAppId: 'eaxg9ake',
  enableDevModule: 'false',
  enableExtarnalAPIs: 'true',
  MOBILE_APP_ID: 'com.wetrack.www',
  disableZoneModal: false,
  DOMAIN: 'wetrack-stage.wetrack.com',
  isOnPremise: false,
  mapProvider: 'com.google.maps',
  CLUSTER_NAME: 'WT-EMEA',
  google_maps: {
    key: 'AIzaSyCObqNsX2CQKc7chaBsh8LDXh5EDcH6DnI',
    version: 'weekly',
      map_id: '13e1ccac041b5186',

    },
    mslConfig: {
        clientId: '592df680-28c8-4d23-98da-3c49307edc52',
        authority: 'https://gomocustomersdev.ciamlogin.com',
        redirectUri: '/' // change redirect url based on where u want to redirect after the authentication
    },
    oauth2Config: {
        appId: '592df680-28c8-4d23-98da-3c49307edc52',
        authorizationBaseUrl: 'https://gomocustomersdev.ciamlogin.com/gomocustomersdev.onmicrosoft.com/oauth2/v2.0/authorize',
        accessTokenEndpoint: 'https://gomocustomersdev.ciamlogin.com/gomocustomersdev.onmicrosoft.com/oauth2/v2.0/token',
        redirectUrl: 'com.wetrack.www://callback',
        scope: 'openid profile email api://592df680-28c8-4d23-98da-3c49307edc52/FullAccess offline_access',
        responseType: 'code',
        pkceEnabled: true,
        logsEnabled: true,
    },
    datadogMonitoring: true,
    datadogService: 'wetrack-fe',
    datadogEnv: 'dev',
};
